import React, { useState, useEffect, useRef } from 'react';
import styles from './LoanUserDetails.scss';
import ButtonRound from '../ButtonRound';
import { ILoanRequestLoanDetails } from '../../utils/LoanRequest';
import useUser from '../../stores/useUser';
import { ILoanCalculatorTextKeys } from './LoanCalculatorPage';
import Select from '../MaterialUi/Select';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

export interface ILoanUserDetailsProps {
    onNextStep: (data: any) => void;
    onPreviousStep: () => void;
    data: ILoanRequestLoanDetails;
    textKeys?: any; // ILoanCalculatorTextKeys['step2'];
}

// export type IOccupation = 'Arbeitsloser' | 'HaushaltendePerson' | 'Angestellter' | 'Arbeiter' | 'Beamter' | 'Selbststaendiger' | 'Freiberufler' | 'Rentner';
export type IOccupation = 'ANGESTELLTER' | 'ARBEITER' | 'BEAMTER' | 'FREIBERUFLER' | 'SELBSTSTAENDIGER' | 'RENTNER' | 'HAUSHALTENDE_PERSON' | 'ARBEITSLOSER';
// | 'HAUSMANN'
// | 'PRIVATIER'
// | 'SOLDAT'
// | 'SCHUELER'
// | 'AZUBI'
// | 'STUDENT'
// | 'OHNE';

// EIGENGENUTZT, VERMIETET,TEILVERMIETET:
export const usageList = {
    EIGENGENUTZT: 'Bewohnen',
    VERMIETET: 'Vermieten',
    TEILVERMIETET: 'Teilvermieten',
};

export const occupationList: { [key in IOccupation]: string } = {
    ANGESTELLTER: 'Angestellte(r)',
    ARBEITER: 'Arbeiter(in)',
    BEAMTER: 'Beamte(r)',
    FREIBERUFLER: 'Freiberufler(in)',
    SELBSTSTAENDIGER: 'Selbstständige(r)',
    RENTNER: 'Rentner(in)',
    HAUSHALTENDE_PERSON: 'Hausfrau/mann',
    ARBEITSLOSER: 'Arbeitssuchende(r)',

    // HAUSMANN: 'Hausfrau/mann',
    // // PRIVATIER: 'Privatier(e)',
    // // SOLDAT: 'Soldat(in)',
    // // SCHUELER: 'Schuler(in)',
    // // AZUBI: 'Auszubildende(r)',
    // // STUDENT: 'Student(in)',
    // OHNE: 'Arbeitssuchende(r)',
};

export const incomeList = {
    '1000': '1000 - 1500 €',
    '1500': '1500 - 2000 €',
    '2000': '2000 - 2500 €',
    '2500': '2500 - 3000 €',
    '3000': '3000 - 3500 €',
    '3500': '3500-4000 €',
    '4000': 'über 4000 €',
};
export const timeList = {
    '0': 'in weniger als 3 Monaten',
    '3': 'in 3-6 Monaten',
    '6': 'in mehr als 6 Monaten',
};

// export interface ILoanUserDetails {
//     given_name?: string;
//     family_name?: string;
//     address_line1?: string;
//     postal_code?: string;
//     locality?: string;
//     phone?: string;
//     mail?: string;
//     birthday?: string;
//     dataProcessingAccepted: boolean;
// }
export interface ILoanDetails {
    occupation?: IOccupation;
    income?: keyof typeof incomeList;
    usage?: keyof typeof usageList;
    time?: keyof typeof timeList;
}

const LoanUserDetails: React.FC<React.PropsWithChildren<ILoanUserDetailsProps>> = ({ data = null, textKeys = null, onNextStep = () => {}, onPreviousStep = () => {} }) => {
    const [loanDetails, setLoanDetails] = React.useState<ILoanDetails>({
        occupation: data?.occupation ? data.occupation : (Object.keys(occupationList)[0] as IOccupation),
        income: data?.income ? data.income : ('2000' as '2000'),
        usage: data?.usage ? data.usage : 'EIGENGENUTZT',
        time: data?.time ? data.time : '0',
    });

    const [user, userActions] = useUser();

    // const handleLoanDetailsChange = (name: string, value: number) => {
    //     setLoanDetails({ ...loanDetails, [name]: value });
    // };

    const handleLoanDetailsChange = (ev) => {
        const target = ev.target;
        const name = target.name;
        const value = target.value;
        setLoanDetails({ ...loanDetails, [name]: value });
    };

    const handleNextStep = (ev: React.FormEvent) => {
        ev.preventDefault();
        onNextStep({
            loanDetails,
            // loanDetails: {
            //     occupation: occupationList[loanDetails.occupation],
            //     income: incomeList[loanDetails.income],
            //     usage: usageList[loanDetails.usage],
            //     time: timeList[loanDetails.time],
            // },
        });
    };

    return (
        <div className={styles.loanUserDetails}>
            <form onSubmit={handleNextStep}>
                <div className={styles.box}>
                    <div className={styles.fields}>
                        <div className={styles.wide}>
                            <label>{textKeys.labels.occupation}</label>
                            <Select
                                // className={styles.select}
                                // label={textKeys.labels.occupation}
                                value={loanDetails.occupation}
                                name="occupation"
                                onChange={handleLoanDetailsChange}
                            >
                                {Object.keys(occupationList).map((key) => {
                                    const val = occupationList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                                {/* {occupationList.forEach((val, idx) => {
                                    return (
                                        <option key={val} value={idx.toString()}>
                                            {val}
                                        </option>
                                    );
                                })} */}
                            </Select>

                            <label>{textKeys.labels.income}</label>
                            <Select
                                // className={styles.select}
                                // label={textKeys.labels.income}
                                value={loanDetails.income.toString()}
                                name="income"
                                onChange={handleLoanDetailsChange}
                            >
                                {Object.keys(incomeList).map((key) => {
                                    const val = incomeList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </Select>

                            <label>{textKeys.labels.usage}</label>
                            <Select
                                // className={styles.select}
                                value={loanDetails.usage.toString()}
                                name="usage"
                                onChange={handleLoanDetailsChange}
                                // label={textKeys.labels.usage}
                            >
                                {Object.keys(usageList).map((key) => {
                                    const val = usageList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </Select>

                            <label>{textKeys.labels.time}</label>
                            <Select
                                // className={styles.select}
                                value={loanDetails.time.toString()}
                                name="time"
                                onChange={handleLoanDetailsChange}
                                // label={textKeys.labels.time}
                            >
                                {Object.keys(timeList).map((key) => {
                                    const val = timeList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div>
                    </div>
                    <div className={styles.actions}>
                        <ButtonRound onClick={onPreviousStep} variant="outlined" icon={<ChevronLeftIcon />} className={styles.back}>
                            zurück
                        </ButtonRound>
                        <ButtonRound type="submit">{textKeys?.button}</ButtonRound>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default LoanUserDetails;
